import React from "react"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import Report from "./report"


const Index = props => {
 
  const { t , openNotification} = props
  return (
      <Report openNotification={openNotification} translate={t} />
  )
}

export default withRouter(withTranslation()(Index))
